import * as Sentry from '@sentry/browser';

if (window.berghsSentry) {
    const { config, queue, push } = window.berghsSentry;

    Sentry.init({
        ...config,
        integrations: [Sentry.contextLinesIntegration()],
    });

    // Expose only the one member we need so the rest of the SDK stays
    // tree-shakeable. Assigning the whole `Sentry` namespace would force the
    // bundler to retain every export.
    window.berghsCaptureException = Sentry.captureException;

    // Take over from the queue the page head installed while this module was
    // still loading, then let Sentry's own global handlers do the job.
    removeEventListener('error', push);
    removeEventListener('unhandledrejection', push);

    for (const event of queue ?? []) {
        Sentry.captureException(event.error ?? event.reason ?? event);
    }

    delete window.berghsSentry.queue;
    delete window.berghsSentry.push;
}
